import { render, staticRenderFns } from "./CategoryLoader.vue?vue&type=template&id=438abdba"
import script from "./CategoryLoader.vue?vue&type=script&lang=js"
export * from "./CategoryLoader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports